import {GeoSegment} from './geoTrackToSegments';
import {Duration} from '../Domain/Duration';
import {Speed} from '../Domain/Speed';

/**
 * Will adjust the speeds of the segments to make correct for any errors in the GPS data.
 * @param geoSegments
 */
export function smoothenGeoSegments(geoSegments: GeoSegment[]): GeoSegment[] {
    //Window size to use to smoothen the data
    const window = Duration.fromSeconds(15);

    return geoSegments.reduce((p: GeoSegment[], c, index, data) => {
        //Find the points forward in the window
        const points: GeoSegment[] = [];
        let cumulativeDuration = Duration.zero();
        for (let i = index; i < data.length; i++) {
            cumulativeDuration = cumulativeDuration.add(data[i].duration);
            if (cumulativeDuration.gte(window)) {
                break;
            }
            points.push(data[i]);
        }

        p.push({
            ...c,
            speed: Speed.average(...points.map((e) => e.speed)),
        });

        return p;
    }, []);
}
